import React, {useCallback, useContext} from 'react';

import {ACTION_CLICK} from '../../data/constants/data-collection-actions';
import {CollectContext} from './CollectContextProvider';
import {useEvent} from '../../data/hooks/eventHooks';
import {useParams} from 'react-router';

/**
 * Collects UI click events
 */
const CollectClick = props => {
    const {children, objectType = null, objectId = null, objectDetail = null} = props,
        {eventId} = useParams(),
        event = useEvent(eventId),
        context = useContext(CollectContext);

    const handleClickCollection = useCallback(() => {
        app.store.dispatch(app.actions.collect.event(ACTION_CLICK, event?.id, objectType, objectId, objectDetail, context));
    }, [objectType, objectId, objectDetail, context]);

    return <span onClick={handleClickCollection}>{children}</span>;
};

export default CollectClick;
